/* eslint @typescript-eslint/no-explicit-any: 0 */
export default (t, f) => {
    let args;
    let timeout;
    return (...thisArgs) => {
        args = thisArgs;
        if (!timeout) {
            timeout = setTimeout(async () => {
                await f(...args);
                timeout = null;
            }, t);
        }
    };
};
//# sourceMappingURL=throttle.mjs.map